import { Outlet } from 'react-router-dom'

export default function Withdrawals() {
    return (
        <Outlet />
    )
}
